import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const TableSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default TableSVG;
